import { render, staticRenderFns } from "./ReportReservations.vue?vue&type=template&id=64577a1f&"
import script from "./ReportReservations.vue?vue&type=script&lang=js&"
export * from "./ReportReservations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports